// src/components/Skeleton/Skeleton.jsx
import React from "react";
// import { cn } from "@/shared/ui/utils"

function Skeleton({ className, ...props }) {
  return (
    <div
      className={`tbk-animate-pulse tbk-rounded-md tbk-bg-blue-grey-light ${className}`}
      {...props}
    />
  );
}

export { Skeleton };
